import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

const Header: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container alignItems="center">
      <Grid item xs>
        <Typography variant="h5" color="textSecondary">
          {t('admin:userManagementTitle')}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Header;
